import types from './types';

/**
 *
 * @param {File} file
 * @param {String} message
 * @param {String} channelId
 */
const uploadAttachmentToChannelRequest = (
  file,
  message,
  channelId
) => ({
  type: types.UPLOAD_ATTACHMENT_TO_CHANNEL_REQUEST,
  file,
  message,
  channelId
});

const uploadAttachmentToChannelSuccess = () => ({
  type: types.UPLOAD_ATTACHMENT_TO_CHANNEL_SUCCESS
});

const uploadAttachmentToChannelFailure = error => ({
  type: types.UPLOAD_ATTACHMENT_TO_CHANNEL_FAILURE,
  error: error.message
});

/**
 * Update store when a new message is received from a channel
 * @param {Object} channelId
 */
const channelReceivedNewMessage = channelId => ({
  type: types.CHANNEL_RECEIVED_NEW_MESSAGE,
  channelId
});

/**
 * Select a channel and save details to store
 * @param {Object} channel
 */
const selectChannel = channel => ({
  type: types.SELECT_CHANNEL,
  channel
});

/**
 * Restore unread messages count from lcoalstorage to redux
 * @param {Object} countsByChannel
 */
const restoreUnreadMessageCount = countsByChannel => ({
  type: types.RESTORE_UNREAD_MESSAGE_COUNT,
  countsByChannel
});

/**
 *
 * @param {Object} query
 * - query keys:
 *   - channelIds: [String]
 *   - senderId: String
 *   - startDate: String
 *   - endDate: String
 */
const managerMessagesOverviewQuery = query => ({
  type: types.MANAGER_MESSAGES_OVERVIEW_REQUEST,
  query
});

/**
 *
 * @param {Object[]} messages
 * @param {Object<String, String>} nextTokens
 */
const managerMessagesQuerySuccess = (
  messages,
  nextTokens
) => ({
  type: types.MANAGER_MESSAGES_OVERVIEW_SUCCESS,
  messages,
  nextTokens
});

const managerMessagesQueryFailure = error => ({
  type: types.MANAGER_MESSAGES_OVERVIEW_FAILURE,
  error
});

export default {
  uploadAttachmentToChannelRequest,
  uploadAttachmentToChannelSuccess,
  uploadAttachmentToChannelFailure,
  channelReceivedNewMessage,
  selectChannel,
  restoreUnreadMessageCount,
  managerMessagesOverviewQuery,
  managerMessagesQuerySuccess,
  managerMessagesQueryFailure
};
